export default __webpack_public_path__ + "static/media/4.734ca9cb.jpg";